// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const UnitSingle = () => {
//   // Extracting unit_id using regular expressions
//   const location = useLocation();
//   // const unit_id = location.pathname.match(/\/class\/(\d+)/);
//   const unit_id = location.pathname.match(/\/unit\/(\d+)/)?.[1];

//   const [unit, setUnit] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchUnit = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/unit/${unit_id}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setUnit(data);
//       localStorage.setItem("classData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (unit_id) {
//       fetchUnit();
//     }
//   }, [unit_id]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Unit Info</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{unit?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{unit?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{unit?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Chapter Name: </span>
//                     <span className="itemValue">
//                       {unit?.data.chapter_names}
//                     </span>
//                   </div>

//                   {/* <div className="detailItem">
//                     <span className="itemKey">Unit: </span>
//                     <span className="itemValue">{unit?.data.name}</span>
//                   </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">
//                       Month in which it will be completed:{" "}
//                     </span>
//                     <span className="itemValue">{unit?.data.month}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Description: </span>
//                     <span className="itemValue">{unit?.data.description}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{unit?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default UnitSingle;



import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const UnitSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const unit_id = location.pathname.match(/\/unit\/(\d+)/)?.[1];
  const [unit, setUnit] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchUnit = async () => {
    try {
      const response = await fetch(`${serverUrl}/unit/${unit_id}`);
      const data = await response.json();
      setUnit(data);
      localStorage.setItem("unitData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (unit_id) {
      fetchUnit();
    }
  }, [unit_id]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Unit Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Unit Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Unit Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Unit Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {unit?.data.name}
                      </h1>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {unit?.data.chapter_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Chapter:</span>
                            <span className="font-medium">{unit.data.chapter_names}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Unit Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Unit Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                      {unit?.data.month && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">Completion Month</label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {unit.data.month}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      {unit?.data.description && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">Description</label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {unit.data.description}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitSingle;